export default "__VITE_ASSET__rqYxF2KX__"